<template>
  <page class="home-page">
    <zui-header :activeIndex="activeIndex"></zui-header>
    <div class="banner vivify fadeIn">
      <h1 class="vivify popIn">
        <span class="br">中小企业数字化转型升级的首选评估咨询伙伴</span>
      </h1>
      <p class="vivify popIn">通过精准的数字化水平测评，助力企业实现高效、可持续的数字化转型升级</p>
    </div>
    <div class="test-serve">
      <h1>企业数字化水平体检服务</h1>
      <div class="test-serve-box">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="6" v-for="item in serveList" :key="item.id">
            <div class="test-serve-item">
              <img :src="item.icon" alt="" />
              <div class="test-serve-item-title">
                <h3>{{ item.text }}</h3>
                <p v-for="(el, index) in item.des" :key="index">{{ el.text }}</p>
                <a href="https://cloud2.yuexin.cn" class="paidviewing" target="_blank">付费查看</a>
              </div>
            </div>
          </el-col>
        </el-row>
        <a
          href="https://rwizqz9fp1.feishu.cn/share/base/form/shrcnRLMhOx5bONvImpJGht0Zvf"
          class="start-button"
          target="_blank"
          >开始体检</a
        >
      </div>
    </div>
    <div class="box-three">
      <div class="default-title">
        <h2>企业为什么要做数字化水平体检？</h2>
        <p class="divider"></p>
      </div>
      <el-row :gutter="100">
        <el-col :xs="24" :sm="12" :md="12">
          <h3 class="title">价值与意义</h3>
          <p>
            帮助企业全面了解自身的数字化水平，发现问题和不足，为未来的数字化转型提供参考和指导。<br />促进企业的持续改进和创新，提高企业的竞争力和市场地位。
          </p>
          <img src="./img/home-1.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12">
          <img src="./img/home-2.png" alt="" />
          <h3 class="title">应用场景</h3>
          <p>
            企业内部对数字化水平的评估和提升，以优化业务流程、提高工作效率。<br />企业间的比较和竞争，以评估自身在行业中的数字化水平和竞争力。<br />投资者和金融机构对企业的评估，以判断企业的潜力和可持续发展能力。
          </p>
        </el-col>
      </el-row>
    </div>
  </page>
</template>
<script>
import './less/home-page.less'
import Logo from '../components/Logo'
import Page from '../components/Page'
import ZuiHeader from '../components/Header'
import icon1 from '../assets/img/test-item-icon1.svg'
import icon2 from '../assets/img/test-item-icon2.svg'
import icon3 from '../assets/img/test-item-icon3.svg'
import icon4 from '../assets/img/test-item-icon4.svg'
// import Util from "../Util";
export default {
  components: { Page, Logo, ZuiHeader },
  data() {
    return {
      activeIndex: '1',
      serveList: [
        {
          id: 1,
          text: '组织架构与流程',
          icon: icon1,
          des: [
            { text: '企业数字化转型' },
            { text: '流程优化与自动化' },
            { text: '内外部协同与信息共享' },
            { text: '人才培养与管理' }
          ]
        },
        {
          id: 2,
          text: '技术基础与设施',
          icon: icon2,
          des: [
            { text: '信息系统建设与集成' },
            { text: '云计算与大数据应用' },
            { text: '安全与隐私保护' },
            { text: '技术创新与研发能力' }
          ]
        },
        {
          id: 3,
          text: '数据管理与分析',
          icon: icon3,
          des: [
            { text: '数据收集与整合' },
            { text: '数据质量与可靠性' },
            { text: '数据分析与洞察' },
            { text: '数据驱动的决策与运营' }
          ]
        },
        {
          id: 4,
          text: '客户体验与营销',
          icon: icon4,
          des: [
            { text: '多渠道客户接触' },
            { text: '个性化营销与推荐' },
            { text: '客户关系管理' },
            { text: '用户体验与满意度' }
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/HomePage.vue